import { ILineOfCreditResponseType } from 'src/types/LineOfCredit';
import { sdk } from 'src/utilities/sdk';

export interface GroupCounts {
  group_id: string;
  diner_count: number;
}

export interface LocCountsResponse {
  object: {
    group_counts: GroupCounts[];
  };
}

export async function getDinerCounts(
  corpId: string,
  ids: string[]
): Promise<LocCountsResponse> {
  return sdk.http.post(
    `/corps/${corpId}/diners/search/diner_count_per_group/`,
    ids
  );
}

export const getGroupIdsFromLocList = (
  locs: ILineOfCreditResponseType[]
): string[] => {
  return Array.from(
    locs.reduce((acc, loc) => {
      loc.tag_invites.forEach(({ id }) => acc.add(id));
      return acc;
    }, new Set<string>())
  );
};

export const getLocHasDiners = (
  loc: ILineOfCreditResponseType,
  dinerCountPerGroups: Record<string, number>
): boolean => {
  return loc.tag_invites?.some(({ id }) => Number(dinerCountPerGroups[id]) > 0);
};
